import React from "react";
import { Form, Button, Row, Col } from 'react-bootstrap';
import { Eye, Home, BuildingHospital, CaretRight, TrendingDown, Notebook, List, ClipboardCheck } from 'tabler-icons-react';
import leftArrow from '../images/leftArrow.png'
import righttArrow from '../images/rightArrow.png'
import btnHome from '../images/btnHomeIcon.png' 
import Languageoptions from './common/languageoptions';

const Generalregistration = () => {
    return (
        <div className="topicSection">

            {/* HOME BUTTON SECTION */}
            <div className="btnHomeSection bounce-in-fwd10">
                <button type="button" className="btnCircle">
                    <img src={btnHome} alt="Date" height="50" width="50" /><br />
               HOME
            </button>
            </div>


            <div className="headerSub">
                <div className="headerSubTitle scale-in-center">
                    <p>
                        PLEASE SCAN OR MANUALLY ENTER YOUR DETAILS
                    </p>
                </div>
            </div>

            <div className="headerName">
                <div className="headerTitle slide-in-top">
                    <div className="iconHospital"></div>
                    <div className="iconNameTitle">GENERAL VISIT</div>
                </div>
            </div>  

            {/* MAIN CONTENT SECTION */}
            <div className="contentPage"> 

                {/* BREADCRUMBS */}
                <div className="breadcrumbs">
                    <ul>
                        <li className="fcolorGreen fade-in-left2"><Home size={50} strokeWidth={2} color={'green'} /> <span className="crumHome">HOME </span>
                            <TrendingDown size={25} strokeWidth={2} color={'green'} />
                        </li>
                        <li className="fcolorGreen fade-in-left3"><BuildingHospital size={40} strokeWidth={2} color={'green'} />
                            <b><i> Step 1</i></b>
                            <br />
                         GENERAL VISIT <CaretRight size={40} strokeWidth={2} color={'green'} />
                        </li>
                        <li className="fcolorRed fade-in-left4"><Notebook size={40} strokeWidth={2} color={'red'} />
                            <b><i> Step 2</i></b> <br />
                        REGISTRATION <CaretRight size={40} strokeWidth={2} color={'red'} />
                        </li>
                        <li className="fcolorGray fade-in-left5"><List size={40} strokeWidth={2} color={'gray'} />
                            <b><i> Step 3</i></b> <br />
                        SUMMARY <CaretRight size={40} strokeWidth={2} color={'gray'} />
                        </li>
                        <li className="fcolorGray fade-in-left6"><ClipboardCheck size={40} strokeWidth={2} color={'gray'} />
                            <b><i> Step 4</i></b> <br />
                        COMPLETE

                        {/* For White space */}
                            <CaretRight size={40} strokeWidth={2} color={'transparent'} />
                        </li>
                    </ul>

                </div>

                {/* ICON BOX */}
                <div className="iconSection3 flip-in-hor-top4">
                    <span>ADVERTISEMENTS</span>
                </div>

                {/* FORM SECTION  */}
                <div className="formSection">
                    <h2 className="fade-in-tl5"><b>VISITOR DETAILS</b></h2>
                    <br />
                    <Form>
                        <Form.Group as={Row} controlId="formGroupVisitorId" className="fade-in-tl6">
                            <Form.Label column sm="4">Visitor ID</Form.Label>
                            <Col sm="8">
                                <Form.Control type="input" size="lg" placeholder="NRIC/FIN/PASSPORT"  maxlength="9"/>
                                <div className="input-group-prepend eyeBtnPos">
                                    <button className="btn btn-info" type="button">
                                        <Eye size={24} strokeWidth={2} color={'white'} />
                                    </button>
                                </div>
                            </Col>
                        </Form.Group>
                        <Form.Group as={Row} controlId="formGroupVisitorName" className="fade-in-tl7">
                            <Form.Label column sm="4">Visitor Name</Form.Label>
                            <Col sm="8">
                                <Form.Control type="input" size="lg" placeholder="Full name" />
                            </Col>
                        </Form.Group>
                        <Form.Group as={Row} controlId="formGroupVisitorMobile" className="fade-in-tl8">
                            <Form.Label column sm="4">Visitor Mobile</Form.Label>
                            <Col sm="8">
                                <Form.Control type="text" size="lg" placeholder="+65 XXXXXXXX" maxlength="8"/>
                            </Col>
                        </Form.Group>
                        {/* <Form.Group as={Row} controlId="formGroupVisitorToken" className="fade-in-tl9">
                            <Form.Label column sm="4">Safe entry token</Form.Label>
                            <Col sm="8">
                                <Form.Control type="input" size="lg" placeholder="123456789" />
                            </Col>
                        </Form.Group> */}
                    </Form>
                </div>


                <div className="footerBtnLeft fade-in-left7">
                    <button type="button" className="btnCircle ">
                        <img src={leftArrow} alt="Arrow Left" height="50" width="50" /><br />
                        BACK
                    </button>
                </div>

                <div className="footerBtnRight fade-in-left8">
                    <button type="button" className="btnCircle">
                        <img src={righttArrow} alt="Arrow Right" height="50" width="50" /><br />
                        NEXT
                    </button>
                </div>


            </div>


            
            {/* language options */}
            <Languageoptions/>

        </div>
    );
};

export default Generalregistration;